module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.buttonClass,
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-709a0d1b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/button.vue
// module id = 865
// module chunks = 34